export class AnnotationEvents {
  public static contextVisible = "context-visible";
  public static contextHidden = "context-hidden";
  public static Reflow = "reflow-annotation-layout";
  public static annotationsLoaded = "annotations-loaded";
  public static annotationsUnloaded = "annotations-unloaded";
}
